import {createContext,useContext,useState} from 'react'
import {useAuth} from './AuthContext'
const DemoContext=createContext(null)
export const useDemo=()=>{const context=useContext(DemoContext);if(!context)throw Error('useDemo requires DemoProvider');return context}
export const DemoProvider=({children})=>{
 const {user,profile,signIn,signInWithGoogle,signUp,signOut}=useAuth()
 const [family,setFamily]=useState(null)
 const [familyMembers,setFamilyMembers]=useState([])
 const [transactions,setTransactions]=useState([])
 const [tasks,setTasks]=useState([])
 const [events,setEvents]=useState([])
 const [shoppingList,setShoppingList]=useState([])
 const [familyPosts,setFamilyPosts]=useState([])
 const [items,setItems]=useState([])
 const [localProfile,setProfile]=useState(null)
 return <DemoContext.Provider value={{isDemoMode:false,user,profile:localProfile||profile,family,familyMembers,transactions,tasks,events,shoppingList,familyPosts,items,setProfile,setFamily,setFamilyMembers,setTransactions,setTasks,setEvents,setShoppingList,setFamilyPosts,setItems,signIn,signInWithGoogle,signUp,signOut,createFamily:async()=>{throw Error('Utilize a página de configuração familiar')}}}>{children}</DemoContext.Provider>
}
export {DemoContext}
